import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useSEO } from "@/lib/seo";
import LegalDocSections from "@/components/public/LegalDocSections";
import { useClientReady } from "@/hooks/useClientReady";

export default function LegalPage({ page }) {
  const embedded = window.INITIAL_DATA?.type === "legal" && window.INITIAL_DATA.payload?.page === page ? window.INITIAL_DATA.payload : null;
  const [doc, setDoc] = useState(embedded?.doc || null);
  const [pc, setPc] = useState(embedded?.page_content || null);
  const clientReady = useClientReady();
  useEffect(() => {
    if (!clientReady) return;
    setPc(null);
    api.get("/website/sections/legal").then((r) => setDoc(r.data)).catch(() => setDoc({}));
    api.get("/public/page-content", { params: { path: `/${page}` } }).then((r) => setPc(r.data)).catch(() => setPc({}));
  }, [clientReady, page]);

  const legacyTitle = doc?.[`${page}_title`] || "";
  const legacyBody = doc?.[`${page}_body`] || "";
  useSEO({ title: `${pc?.title || legacyTitle || "Legal"} — Training Basket`, description: (pc?.paragraphs?.[0] || legacyBody).replace(/<[^>]+>/g, "").slice(0, 150) });

  if (pc === null) return null;
  const hasPc = pc.title || (pc.paragraphs || []).length > 0;
  const data = hasPc
    ? pc
    : { title: legacyTitle, paragraphs: legacyBody.split("\n\n").filter(Boolean) };
  return <LegalDocSections data={data} pageKey={page} />;
}
